export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 85,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('INDEX.table_label_delivery_batch_No') || '交货批次号',
    field: 'orderBatchNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_mrpFabricPlanNo') || '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_deliveryDate') || '出货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_deliveryDate') || '出单类型',
    field: 'outBillType',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_packing_dispatchPort') || '发运港口',
    field: 'dispatchPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_packing_destinationPort') || '目的港口',
    field: 'destinationPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
